import { Helmet } from "react-helmet-async";
import { SITE_URL } from "@/lib/seo";

// Per-page SEO: title, description, canonical, Open Graph & Twitter.
export default function Seo({ title, description, path = "/", noindex = false }) {
    const url = `${SITE_URL}${path}`;
    return (
        <Helmet prioritizeSeoTags>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="robots" content={noindex ? "noindex, follow" : "index, follow"} />
            <link rel="canonical" href={url} />

            {/* Per-page Open Graph */}
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />

            {/* Per-page Twitter */}
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
        </Helmet>
    );
}
